import { useEffect, useState } from "react";

const UseNavbarHeight = () => {
  const [navbarHeight, setNavbarHeight] = useState<number>();

  useEffect(() => {
    const el = document.querySelector(`#category-nav`);
    const resizeObserver = new ResizeObserver(() => {
        setNavbarHeight(el?.clientHeight);
    });

    if (el) resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, []);

  return [navbarHeight, setNavbarHeight];
};

export default UseNavbarHeight;